import React from 'react';
import '../Routes.css';

function Profile() {
  return (
    <div className="page__container">
      <h1 className="page__heading">Profile</h1>
    </div>
  );
}

export default Profile;
